import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { ConstantsService } from '../constants.service';


@Injectable({
  providedIn: 'root'
})
export class BookingInfoService {

  constructor(private http: HttpClient, private constantsService: ConstantsService) { }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }

  getAllBookingInfo(data : any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/getAllBookingInfo`,data, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getAllBookingInfoForContainer(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/exports/getAllBookingInfoForContainer`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getAllServiceProviders(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/exports/getAllServiceProviders`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  addBookingInfo(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/insertorUpdateBooking`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  updateBookingInfo(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/updateBooking`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  deleteBookingInfo(body: any): Observable<any> {
    let wayBillNo = {'waybill':body}
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/deleteBookingInfo/${wayBillNo.waybill}`,  { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  public uploadData(upload:any): Observable<any> {
    console.log('upload ' , upload)
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/uploadData`,upload)
      .pipe(
        catchError(this.handleError));
    }
    public booking(upload:any): Observable<any> {
      console.log('upload ' , upload)
      return this.http
        .post(`${this.constantsService.baseAPIURL}/exports/booking`,upload)
        .pipe(
          catchError(this.handleError));
      }
  getWayBillNumber(body: any): Observable<any> {
    let wayBillNo = {'waybill':body}
    return this.http
      .get(`${this.constantsService.baseAPIURL}/exports/findWayBill/${wayBillNo.waybill}`,  { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getModuleData(data : any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/getAllPDFModule`, data, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getModuleDetails(data : any): Observable<any>
  {
    return this.http
    .post(`${this.constantsService.baseAPIURL}/exports/getPDFModuleDetails`, data, { headers: this.constantsService.httpOptions })
    .pipe(
      catchError(this.handleError));
  }
  getContainerData(data : any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/getAllPDFContainer`, data, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getContainerDetails(data : any): Observable<any>
  {
    return this.http
    .post(`${this.constantsService.baseAPIURL}/exports/getAllPDFContainerDetails`, data, { headers: this.constantsService.httpOptions })
    .pipe(
      catchError(this.handleError));
  }
  getContainerDetails1(data : any): Observable<any>
  {
    return this.http
    .post(`${this.constantsService.baseAPIURL}/exports/getAllPDFContainerDetails1`, data, { headers: this.constantsService.httpOptions })
    .pipe(
      catchError(this.handleError));
  }
  getAllInfo(data : any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/getAllInfo`,data, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getAllRenban(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/exports/getAllRenban`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }

  createContainer(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/createContainer`,body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  updateContainer(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/updateContainer`,body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getLoad(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/exports/getLoad`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  insertLoadType(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/insertLoadType`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  getShipType(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/exports/getShipType`, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  updateLoadType(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/updateLoadType`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  deleteLoad(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/deleteLoad`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
  deleteContainer(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/deleteContainer`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }  
  reopenContainer(body: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/exports/reopenContainer`, body, { headers: this.constantsService.httpOptions })
      .pipe(
        catchError(this.handleError));
  }
}
